import { render } from "./LoadingItem.vue?vue&type=template&id=6069dd05"
const script = {}

import "./LoadingItem.vue?vue&type=style&index=0&id=6069dd05&lang=css"

import exportComponent from "C:\\www\\RACE_PARTNER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__